<!-- 能耗管理 -->
<style lang="scss" scoped>
.powerXh {
  pointer-events: all;
  position: relative;
}
</style>
<template>
  <div class="powerXh">
    <template v-if="getRouteName === pagesName">
      <custom-return></custom-return>
      <index-page></index-page>
    </template>
    <template v-else>
      <router-view></router-view>
    </template>
  </div>
</template>

<script>
import IndexPage from "./pages/index-page/index.vue";
import bus from "@/components/three-scene/Bus.js";
export default {
  data() {
    return {
      pagesName: "third",
    };
  },
  computed: {
    getRouteName() {
      return this.$route.name;
    },
  },
  components: { IndexPage },
  mounted(){
    bus.emit('initDom')
    bus.emit('initDom1')
  }
};
</script>
